import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import IMAGES from '../images';
import './Hero.css';

const SLIDES = [
  {
    img: IMAGES.collectionOlea,
    label: 'Nouvelle Collection 2024',
    title: ['Olea Aurea', "L'or de l'olivier"],
    italic: true,
    cta: 'Découvrir la Collection',
    link: '/collection-heritage',
  },
  {
    img: IMAGES.douches,
    label: 'Robinetterie Artisanale',
    title: ['Façonné', 'à la main'],
    italic: true,
    cta: 'Explorer',
    link: '/robinetterie',
  },
  {
    img: IMAGES.vasquesMarbre,
    label: 'Vasques Nobles',
    title: ['Marbre & Laiton', 'Matières Vivantes'],
    italic: true,
    cta: 'Voir les Vasques',
    link: '/vasques',
  },
  {
    img: IMAGES.designer,
    label: 'Artisanat Tunisien',
    title: ['Khansa Yazidi', 'Le Savoir-faire'],
    italic: true,
    cta: 'Notre Histoire',
    link: '/contact',
  },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = (index) => {
    if (transitioning || index === current) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setTransitioning(false);
    }, 400);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goTo((current + 1) % SLIDES.length);
    }, 5500);
    return () => clearInterval(interval);
  }, [current, transitioning]);

  const slide = SLIDES[current];

  return (
    <section className="hero">
      {/* Background images preloaded */}
      {SLIDES.map((s, i) => (
        <div
          key={i}
          className={`hero__bg ${i === current ? 'hero__bg--active' : ''}`}
          style={{ backgroundImage: `url(${s.img})` }}
        />
      ))}

      {/* Overlay */}
      <div className="hero__overlay" />

      {/* Content */}
      <div className={`hero__content ${transitioning ? 'hero__content--out' : 'hero__content--in'}`}>
        <span className="hero__label">{slide.label}</span>
        <h1 className="hero__title">
          {slide.title[0]}
          {slide.title[1] && (
            <>
              <br />
              <em>{slide.title[1]}</em>
            </>
          )}
        </h1>
        <Link to={slide.link} className="hero__btn">
          {slide.cta}
        </Link>
      </div>

      {/* Slide indicators */}
      <div className="hero__indicators">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            className={`hero__dot ${i === current ? 'hero__dot--active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Progress bar */}
      <div className="hero__progress">
        <div key={current} className="hero__progress-bar" />
      </div>

      {/* Scroll cue */}
      <div className="hero__scroll">
        <span>Défiler</span>
        <div className="hero__scroll-line" />
      </div>
    </section>
  );
}
